export const NOT_MIX_REPORTING_TYPES = ['SELF_REPORTING', 'EMPLOYER'];
